import React from 'react';
import { Box } from '@mui/material';
import { PREVIEW_MAGNIFIER } from '../../../constants/enum';
import { white } from '../../../constants/colors';

interface ImageMagnifierProps {
  imageUrl: string;
  displayedWidth: number; // コンテナ内で実際に表示されている画像の幅
  displayedHeight: number; // コンテナ内で実際に表示されている画像の高さ
  imageOffsetX: number; // コンテナ内での画像表示開始X座標
  imageOffsetY: number; // コンテナ内での画像表示開始Y座標
  mouseX: number; // コンテナ内のマウスX座標
  mouseY: number; // コンテナ内のマウスY座標
}

const ImageMagnifier: React.FC<ImageMagnifierProps> = ({
  imageUrl,
  displayedWidth,
  displayedHeight,
  imageOffsetX,
  imageOffsetY,
  mouseX,
  mouseY,
}) => {
  const { WIDTH, HEIGHT, SCALE, BORDER_WIDTH, Z_INDEX } = PREVIEW_MAGNIFIER;
  const halfW = WIDTH / 2;
  const halfH = HEIGHT / 2;

  // マウスが画像の内側にあるか判定（外側なら描画しない）
  const relativeX = mouseX - imageOffsetX;
  const relativeY = mouseY - imageOffsetY;
  if (relativeX < 0 || relativeY < 0 || relativeX > displayedWidth || relativeY > displayedHeight) {
    return null;
  }

  // ルーペ自体の配置（画像領域内で clamp してはみ出しを防ぐ）
  const minLeft = imageOffsetX;
  const maxLeft = imageOffsetX + Math.max(displayedWidth - WIDTH, 0);
  const minTop = imageOffsetY;
  const maxTop = imageOffsetY + Math.max(displayedHeight - HEIGHT, 0);
  const rawLeft = mouseX - halfW;
  const rawTop = mouseY - halfH;
  const left = Math.min(Math.max(rawLeft, minLeft), maxLeft);
  const top = Math.min(Math.max(rawTop, minTop), maxTop);

  // ルーペ内の背景画像：表示画像全体を SCALE 倍したサイズで敷く
  const bgWidth = displayedWidth * SCALE;
  const bgHeight = displayedHeight * SCALE;
  // マウス位置を拡大して、ルーペ中央に来るよう背景位置を算出
  const bgX = -relativeX * SCALE + halfW;
  const bgY = -relativeY * SCALE + halfH;

  return (
    <Box
      sx={{
        position: 'absolute',
        left: `${left}px`,
        top: `${top}px`,
        width: `${WIDTH}px`,
        height: `${HEIGHT}px`,
        border: `${BORDER_WIDTH}px solid ${white}`,
        borderRadius: '4px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.35)',
        backgroundImage: `url("${imageUrl.replace(/"/g, '%22')}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: `${bgWidth}px ${bgHeight}px`,
        backgroundPosition: `${bgX}px ${bgY}px`,
        pointerEvents: 'none',
        zIndex: Z_INDEX,
        '@media (max-width: 600px)': {
          display: 'none',
        },
      }}
    />
  );
};

export default ImageMagnifier;
